import { useQuery } from '@tanstack/react-query';

import { API_MAX_LIMIT } from '@/constants';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { NestedNullable } from '@/types/types';

import { EconomicalValueChannelSourceFilters, EconomicalValueChannelSourceType } from '../types';

import { channelsQueryKeys } from './query-keys';

export async function getEconomicalValueChannelSources(
  params?: NestedNullable<EconomicalValueChannelSourceFilters>
): Promise<EconomicalValueChannelSourceType[]> {
  return mediaManagerClient
    .get('/api/v1/economical_value_channel_sources', {
      params: (() => {
        const queryParams: Record<string, unknown> = {};

        if (params?.idIn && params.idIn.length > 0) {
          queryParams['id__in'] = params.idIn.join(',');
        }
        if (params?.scopeIn) {
          queryParams['scope__in'] = params.scopeIn;
        }
        if (params?.mediaTypeIn) {
          queryParams['media_type__in'] = params.mediaTypeIn;
        }
        if (params?.countryIn) {
          queryParams['country__in'] = params.countryIn;
        }
        if (params?.regionIn) {
          queryParams['region__in'] = params.regionIn;
        }

        queryParams['limit'] = params?.limit ?? API_MAX_LIMIT;

        return queryParams;
      })(),
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getEconomicalValueChannelSources;

interface UseSegmentsParams {
  config?: QueryConfig<QueryFnType>;
  params?: NestedNullable<EconomicalValueChannelSourceFilters>;
}

export function useEconomicalValueChannelSources({ config, params }: UseSegmentsParams = {}) {
  return useQuery({
    ...config,
    queryKey: channelsQueryKeys.economicalValueChannelSources(params),
    queryFn: () => getEconomicalValueChannelSources(params),
  });
}
